import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, testId }) {
  return (
    <Reveal>
      <p className="font-tech text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">{eyebrow}</p>
      <h2
        data-testid={testId}
        className="font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-none"
      >
        {title}
      </h2>
    </Reveal>
  );
}
